const testimonials = [
  // Group 1
  {
    ru: "Я в том году начитался наверно все что ты сейчас читаешь. Я так и не решился один.",
    en: "Last year, I probably read everything you're reading now. I never dared to do it alone.",
  },
  {
    ru: "Блин, Коль, ты уже прозрел:) но достучаться сложно, надо пройти путем и получить опыт. И осознать. А путь все таки индивидуален. Меня подвытащил точно",
    en: "Man, you've already seen the light :) But it's hard to get through, one has to go through the journey and gain experience himself. And understand. The path is still individual. It certainly pulled me out.",
  },
  {
    ru: "Утро доброе! Коль, открываю утром телеграм и бегу смотреть что ты написал. Спасибо",
    en: "Good morning! I open the notebook in the morning and rush to see what you've written. Thank you.",
  },
  {
    ru: "Ребенок стал более спокойный. Он вроде такой же, но просто ровнее. Спасибо 👍",
    en: "The child has become calmer. He's the same, but just more even-tempered. Thanks 👍.",
  },
  {
    ru: "Что то я часто стал в детство возвращаться",
    en: "I've been finding myself returning to childhood quite often.",
  },
  {
    ru: "Мне только после стало доходить вообще о чем книжки",
    en: "It was only afterwards that I started to grasp what the books were really about.",
  },
  {
    ru: "Я не попробовал бы сам если бы не ты, но я не интересовался и не читал ничего до этого момента.",
    en: "I wouldn't have tried it myself if it weren't for you, but I wasn't interested and hadn't read anything until that moment.",
  },
  {
    ru: "Если бы мне твоя программа например попалась лет 7-8 назад, я бы наверно прыгнул в самолет и прилетел.",
    en: "If I had come across your program like 7-8 years ago, I probably would have jumped on a plane and flown over.",
  },
  {
    ru: "Я как эта история началась давно не помню себя в депрессии.",
    en: "Since this story started, I hardly remember feeling depressed.",
  },
  {
    ru: "Так и в бога поверишь...",
    en: "This makes you believe in God...",
  },
  {
    ru: "Все как должно быть что ли?",
    en: "Is everything as it should be, perhaps?",
  },
  {
    ru: "Что-то у меня от одного разговора уже, кажется, бооольшой эффект",
    en: "Seems like I'm already feeling a huuuge effect from just one conversation.",
  },

  // Group 2
  {
    ru: "Привет, Коля! Ошеломительный опыт",
    en: "Hi, Nick! An astounding experience.",
  },
  {
    ru: "Это лучшее что было в моей жизни) Спасибо ♥️",
    en: "This is the best thing that happened in my life) Thank you ♥️.",
  },
  {
    ru: "Надеюсь на продолжение, так как очень понравилось.",
    en: "Hoping for a continuation, as I really liked it.",
  },
  {
    ru: "Очень понравилось - даже не те слова. Не с чем сравнить - было бы точнее.",
    en: "Liked it a lot - even that's an understatement. 'Nothing to compare it with' would be more accurate.",
  },
  {
    ru: "Очевидность мысли, как мысль формирует поле видение себя со стороны, встреча с Богом.",
    en: "The obviousness of thought, how thought shapes the field of self-perception from outside, meeting with God.",
  },
  {
    ru: "Любовь - на всё ответ в итоге. Та самая, которая творит миры внутри и снаружи.",
    en: "Love - ultimately, the answer to everything. The very one that creates worlds inside and outside.",
  },
  {
    ru: "Огромная благодарность за этот незабываемый и значимый опыт! Это очень ценно!",
    en: "Immense gratitude for this unforgettable and significant experience! It's very valuable!",
  },
  {
    ru: "Польза для жизни: появилось состояние безопасности мира. Иногда оно забывается, но оно есть во мне.",
    en: "Life benefit: a sense of world safety emerged. Sometimes it's forgotten, but it's there in me.",
  },
  {
    ru: "Всё это вместе переместило меня в совершенно новое пространство, которое имеет потенциал развернуться ещё более новым опытом и качественно другим проживанием себя, проявлением себя.",
    en: "All of this together moved me into a completely new space, which has the potential to unfold into an even newer experience and a qualitatively different way of living and expressing myself.",
  },
  {
    ru: "Коля, привет, у меня тут все становится на свои места в голове и укладывется, как надо! Процесс идет! Спасибо вам обоим, вы даже не представляете, что вы сделали 😀",
    en: "Hello, Kolya, everything's falling into place in my head and settling as it should! The process is ongoing! Thank you both, you can't even imagine what you've done 😀.",
  },
  {
    ru: "Теперь буду выбивать следующую командировку сюда 😀",
    en: "Now I'll be vying for another trip here 😀.",
  },
  {
    ru: "Такая приятная грусть, я рада, что все так классно получилось !",
    en: "Such pleasant sadness, I'm glad that everything turned out so great!",
  },
  {
    ru: "Раньше слышала мне казалось что это такой прекраснодушный бред",
    en: "I used to hear and think it was such a beautifully crazy nonsense.",
  },
  {
    ru: "У меня было ощущение, что нельзя уже ничего вернуть… что все так, как есть, и выхода нет",
    en: "I had a feeling that nothing could be undone anymore… that things are as they are, with no way out.",
  },
  {
    ru: "Я вижу что еще есть жизнь впереди и какой она будет, зависит только от меня",
    en: "I see now that there's still life ahead and how it will be is up to me.",
  },
  {
    ru: "Мне казалось, что ничего нового и интересного уже особо не будет",
    en: "I thought nothing new or interesting would happen again.",
  },
  {
    ru: "Сейчас такое состояние наполненности. Не хочется расплескать, когда начнется обычная жизнь вне Пхукета 😀",
    en: "Currently, I'm in a state of fulfillment. Don't want to spill it when regular life starts outside Phuket 😀.",
  },
  {
    ru: "Я даже не психую сейчас ни от чего, хотя еще неделю назад психовала бы",
    en: "I'm not freaking out about anything right now, even though I would have a week ago.",
  },
  {
    ru: "Смысл в том, что я не не на то тратила свою силу и энергию",
    en: "The point is that I wasn't spending my strength and energy on the right things.",
  },
  {
    ru: "У меня в голове появился смысл 😀",
    en: "A sense of purpose has emerged in my mind 😀.",
  },
  {
    ru: "Спасибо большое вам обоим! Это было ни с чем несравнимо !!!",
    en: "Thank you both so much! It was incomparable !!!",
  },

  // Group 3
  {
    ru: "Все пересекается гармонично, под нашу настройку да?",
    en: "Everything shapes up harmoniously, to our tuning, right?",
  },
  {
    ru: "Вобщем у меня такое: чувствую себя молодо, не оценивая себя, не нуждаюсь в оправдании своего существования.",
    en: "So here's my thing: I feel young, without judging myself, not needing to justify my existence.",
  },
  {
    ru: "Вернулось я - это я, а не приложение для работы, работы по дому, отдания долга предкам.",
    en: "I returned to being me - not just an app for work, housework, or repaying ancestral debts.",
  },
  {
    ru: "Просто оказалось что я тут композитор и дирижер, и музыка для меня. Просто живу.",
    en: "Turns out, I'm the composer and conductor here, and the music is for me. Just living.",
  },
  {
    ru: "А сейчас отпустило. Все же хорошо. Я так же их люблю и забочусь, но без разрывания себя на куски",
    en: "And now it's let go. Everything is fine. I still love and care for them, but without tearing myself apart.",
  },
  {
    ru: "Прав ты был, когда говорил что это то к чему люди годами идут через психотерапию и пр.",
    en: "You were right when you said that this is what people take years of psychotherapy to reach.",
  },
  {
    ru: "Ты показал мои true colors в моем сияющем небе",
    en: "You revealed my true colors in my shining sky.",
  },
  {
    ru: "Был момент когда я испугалась что я не вернусь в «нормальную жизнь с пятерочкой»",
    en: "There was a moment when I was scared that I wouldn't return to a 'normal life with grades'.",
  },
  {
    ru: "Я все помню!",
    en: "I remember everything!",
  },
  {
    ru: "Подписана на тебя пожизненно!",
    en: "I'm subscribed to you for life!",
  },
  {
    ru: "Путешествие в подсознание.",
    en: "A journey into the subconscious.",
  },
  {
    ru: "И знаешь, вот ощущение, что все хорошо",
    en: "And you know, I have this feeling that everything is alright.",
  },
  {
    ru: "Мне кажется у меня в целом мозг стал живым в плане улетов фантазии",
    en: "I think my brain in general has become alive in terms of flights of fantasy.",
  },

  // Group 4
  {
    ru: "Все херня, Николай был прав, придерживаюсь исключительно его заветам",
    en: "Everything else is nonsense, Nick is right, I strictly adhere to his teachings.",
  },
  {
    ru: "Еще раз, все что пишет Николай - истина",
    en: "Again, everything Nick writes is the truth.",
  },
  {
    ru: "Я не верил в рассказы Николая порядка года-двух",
    en: "I didn't believe in Nick's stories for about a year or two.",
  },
  {
    ru: "Вобщем все что мне вещал Николай - правда. Хочешь быть пси-мутированной собакой, делай как он",
    en: "In short, everything Nick told me is true. If you want to be a psi-mutated dog, do as he does.",
  },
  {
    ru: "Я по твоим заветам стал жить",
    en: "I started living by your teachings.",
  },
  {
    ru: "Лучшее решение в жизни",
    en: "The best decision in life.",
  },

  // Group 5
  {
    ru: "Нет, не самовнушение. Я тоже испытал восторг от того какой на самом деле мир может быть классным.",
    en: "No, it's not self-delusion. I too was thrilled by how cool the world can actually be.",
  },
  {
    ru: "После этого моя картина мира разделилась на множество факторов которые формируют ее.",
    en: "After that, my worldview split into many factors that shape it.",
  },
  {
    ru: "До этого это была монолитная серая плоская картина мира.",
    en: "Before, it was a monolithic, grey, flat picture of the world.",
  },
  {
    ru: "Cтараюсь распознать и улучшить каждый элемент, который выходит из под контроля и вносит в желаемую мной картину несоответствующие краски.",
    en: "I try to recognize and improve each element that gets out of control and brings inappropriate colors into the picture of the world I desire.",
  },
  {
    ru: "И я бы этого не понял и не осознал сейчас если бы ты не поделился этим",
    en: "And I wouldn't have understood or realized this now if you hadn't shared it.",
  },
  {
    ru: "Занимаюсь исправлением красок, мелких деталей моей картины Мира. Каждый из нас — художник своей жизни)",
    en: "I'm working on correcting the colors, the small details of my World picture. Each of us is the artist of our life)",
  },

  // Group 6 - originally English
  {
    ru: "Бро, если у тебя есть тайная сила разруливать людей - делай это как можно больше, я считаю 😁",
    en: "Bro if you have the secret powers to sort people out, do it as much as possible I say 😁",
  },
  {
    ru: "Жалею что не начал раньше 😬 Это потрясающе, чувак!",
    en: "I wish I'd started sooner as well 😬 This is amazing man!",
  },
  {
    ru: "Все отлично. Бросил курить месяц назад.",
    en: "Doing amazing. Quit smoking a month ago.",
  },
  {
    ru: "Удается держать алкоголь под контролем без особых усилий.",
    en: "Am managing to keep the alcohol at bay without much trouble.",
  },
  {
    ru: "Спазм в спине отпустил сам... через 5 км я такой — ого, вчера это было невозможно.",
    en: "My back spasm released itself...5 kms later I was like - whoa, this was impossible just yesterday.",
  },
  {
    ru: "Ахахах увидимся в январе, приеду второй раз!",
    en: "hahahah I will see you in January for my second trip!",
  },
  {
    ru: "Я запомнил камни и деревья как бодхисаттв из того путешествия, и теперь вижу их повсюду — мягко улыбаются и присматривают за мной.",
    en: "I remember the rocks and trees as bodhisatvas from that trip and now I see them everywhere, gently smiling and looking out for me.",
  },
  {
    ru: "Я все время вспоминаю как ты стоял в дверях, светился, потому что уже накрыло, и говорил мне — наслаждайся жизнью.",
    en: "I keep remembering you standing in the door, glowing because the trip had kicked in and saying to me - enjoy your life.",
  },
  {
    ru: "Я просто сосредоточен на домашке и на том чтобы прийти в форму.",
    en: "I'm just focused on the homework and getting healthy.",
  },
  {
    ru: "Напиши книгу, чувак. Книг много, и каждая находит своего читателя.",
    en: "Please write it man. There are so many books and they all find the readers they need to.",
  },
  {
    ru: "Мало что помню о Бангкоке кроме сумасшедшего русского 😋",
    en: "Don't remember much else about BKK than the crazy Russian 😋",
  },
  {
    ru: "Черт, да. Делай. Похоже это твое призвание.",
    en: "Fuck yes. Do it. Seems this is your calling.",
  },
  {
    ru: "Бытовуха конечно вернулась, но я благодарен за новый взгляд на вещи",
    en: "The struggles of daily life have certainly returned but I'm grateful for the perspective",
  },
  {
    ru: "Хочу исследовать дальше!",
    en: "I want to explore more!",
  },
  {
    ru: "Вернулся домой с обновленной благодарностью к семье и жене",
    en: "Came home with such a renewed appreciation for my family and my wife",
  },
  {
    ru: "Очень интересная интроспекция о том какие стимулы я впускаю в свою жизнь каждый день. Много мета-перспективы о жизни.",
    en: "Also really interesting introspection on the stimulus I let into my life daily. Lots of meta perspective about life.",
  },
]

const lang = document.documentElement.lang === "ru" ? "ru" : "en"
const texts = testimonials.map(t => t[lang]).sort(() => Math.random() - 0.5)

const testimonialContainer = document.getElementById("testimonials");

function addTestimonial(text) {
  const testimonial = document.createElement("div");
  testimonial.classList.add("testimonial-box", "bg-sky-100");
  testimonial.style.left = `${Math.round(Math.random() * (window.innerWidth - 316))}px`;

  testimonial.textContent = text;

  testimonialContainer.appendChild(testimonial);


  setTimeout(() => {
    testimonial.remove();
  }, 5900);
}

let index = 0;

function showTestimonials() {
  if (index < texts.length) {
    const testimonialText = texts[index];
    addTestimonial(testimonialText);
    index++;
  } else {
    index = 0;
  }
}

if(testimonialContainer) {
  setTimeout(() => {
    setInterval(showTestimonials, 6000);
  }, 6000);
}
